import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-select-menu',
  templateUrl: './select-menu.component.html',
  styleUrls: ['./select-menu.component.scss']
})
export class SelectMenuComponent {
  
  constructor() { }
}
